export default __webpack_public_path__ + "static/media/download-on-appstore.20eb0b26.png";